import axios from "../helpers/bearerAxios";
import { isBoxUploadEnabled } from "../helpers/featureFlags";
import { logger } from "./loggingService";

export const getDocumentsList = async (docType: string) => {
    return await axios.get(`${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_FETCH_DOCS_URL}?documentTypeName=${docType}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            logger.error(error);
            return error;
        })
}


export const downloadEngineeringDocFile = async (payload: any, onProgress: any) => {
    try {
        return await axios.post(`${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_DWN_ENGG_FILE_URL}`, payload, {
            responseType: 'blob',
            onDownloadProgress: ({ total, loaded }: any) => {
                const percentCompleted = Math.round((loaded * 100) / total);
                onProgress?.(payload.fileName, percentCompleted);
            }
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            logger.error(error);
            return error;
        });

    } catch (error) {
        logger.error(error, 'Error downloading file:');
    }
};


export const uploadToBox = async (oppId: string, file: any, onProgress: (progress: number) => void) => {
    if (!isBoxUploadEnabled() && oppId !== '006Pl000009urMIIAY') { // Hard coded oppId for testing purpose
        logger.error('Box Upload is not enabled');
        return;
    }

    let url = `${import.meta.env.VITE_BASE_URL}/api/Opportunities/${oppId}/BoxFiles`

    const formData = new FormData();
    formData.append('file', file.data, file.name);

    return await axios.post(url, formData, {
            onUploadProgress : (progressEvent: any) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
                  onProgress(percentCompleted);
            }
        })
        .then((response) => true)
        .catch((error) => {
            logger.error(error);
            return false;
        });
};

export const downloadPackingSlipDocument = async (
    customerNumber: string,
    shorten: boolean,
): Promise<Blob> => {
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_ONEDOC_BASE_URL}/api/OneDoc/PackingSlip`,
            {
                CustomerNumber: customerNumber,
                Shorten: shorten,
            },
            {
                responseType: 'blob',
            });

        return response.data;
    } catch (error) {
        logger.error(error);
        throw error;
    }
}